<template>
  <div class="main-application">
    <a
      id="skip-link"
      tabindex="1"
      :aria-label="displayText"
      :style="cssStyles"
      :href="'#' + id"
    >
      <v-icon
        v-if="showIcon"
        :color="textColor"
        class="mr-2"
      >
        arrow_right_alt
      </v-icon>
      {{ displayText }}
    </a>
    <slot />
  </div>
</template>

<script>
export default {
  name: "SkipLink",
  props: {
    id: {
      type: String,
      default: null
    },
    displayText: {
      type: String,
      default: "Skip to main content"
    },
    backgroundColor: {
      type: String,
      default: "primary"
    },
    textColor: {
      type: String,
      default: "primary"
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cssStyles() {
      return {
        "--backgroundColor": this.backgroundColor,
        "--textColor": this.textColor
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

#skip-link {
  position: fixed;
  height: 30px;
  width: 100%;
  padding-left: 24px;
  display: flex;
  align-items: center;
  background-color: var(--backgroundColor);
  color: var(--textColor);
  z-index: 2;
  border-radius: 0;
  border: none;
  text-decoration: none;
  transform: translateY(-100%);

  &:focus {
    transform: translateY(0);
  }

  &::before {
    background-color: var(--backgroundColor);
  }
}

#skip-link:focus ~ {
  header {
    margin-top: 30px !important;
  }

  nav {
    top: 94px !important;
  }

  main {
    padding-top: 94px !important;
  }
}
</style>
